import React from 'react';
import './costs.scss';
import {Logout,SevenDaysFormatted, TodayFormatted} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Format,
  Column,
  Button,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  Lookup,
  Popup,
  Form,
  Editing,
  Selection,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel,
  Toolbar
  //Item
} from 'devextreme-react/data-grid';

import { useState, useEffect, useCallback} from "react";

// import { Workbook } from 'exceljs';
// import { saveAs } from 'file-saver';
// import { exportDataGrid } from 'devextreme/excel_exporter';

//import { confirm } from 'devextreme/ui/dialog';
import {Button as ToolbarButton} from 'devextreme-react/button';
import { Item } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import {
  RequiredRule
} from 'devextreme-react/form';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Transazione';


export default function SupplierInvoiceTransactions(props) {

    var transactionsSupplierDataGridRef = React.createRef();

    const [intermediari, setIntermediari] = useState({});
    const [categorie, setCategorie] = useState({});
    const [modalitaPagam, setModalitaPagam] = useState({});

    const [currentRow, setCurrentRow] = useState(1);
    const [isRowSelected, setIsRowSelected] = useState(false);

    const [hasPagamenti, setHasPagamenti] = useState(false);
    const editorOptions = { readonly: true, format: '#,##0.00'};

    const { user } = useAuth(); 

    const PAGAMENTI = 1;

    if (!user) 
      Logout();

    const filterPayload = { 
      idSuper: props.data.id,
      docType: PAGAMENTI
    };


    const remoteDataSourceDue = createStore({
        key: 'id',
        loadUrl: serviceUrl + '/Find',
        //loadUrl: serviceUrl + '/GetAction',
      
        onBeforeSend: (method, ajaxOptions) => {
          if (method === "load" ) {           
              var payload = ajaxOptions.data;
              payload.values = JSON.stringify(filterPayload);
              ajaxOptions.data = payload;          
          }  
          ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
         ;
        },
        //loadUrl: serviceUrl2 + '/GetAction',
        insertUrl: serviceUrl + '/InsertAction',
        updateUrl: serviceUrl + '/UpdateAction',
        deleteUrl: serviceUrl + '/DeleteAction'  
    });

    useEffect(() => {
    
        const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
        var newUrl5 =  newServiceUrl5 + "/GetAction";
    
        const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
        var newUrl7 =  newServiceUrl7 + "/GetIntermediari";
    
        const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CategoriaAnalitica';
        var newUrl12 =  newServiceUrl12 + "/GetAction";

        const fetchData = async () => {
          try {

            const requestOptions = {
              headers: {
                Authorization: `Bearer ${user.token}`
              }
            };
    
            const response5 = await fetch(newUrl5);
            const json5 = await response5.json();
            //console.log(json5);
            setModalitaPagam(json5);
    
            const response7 = await fetch(newUrl7,requestOptions);
            const json7 = await response7.json();
            console.log(json7);
            setIntermediari(json7);

            const response12 = await fetch(newUrl12);
            const json12 = await response12.json();
            console.log(json12);
            setCategorie(json12);
    
          } catch (error) {
            console.log("error", error);
          }
        };
        fetchData();
      }, []);

const onCellPreparedDue = (e) => {

    if (e.rowType === "data") {

      if (e.column.dataField === "dataScadenza" || e.column.dataField === "giorniScadenza") 
      {
        var dataScadenza = e.data.dataScadenza;
        var dataPagamento = e.data.dataPagamento;
        //console.log("SCADENZA: " + dataScadenza);
        //console.log("OGGI: " + todayFormatted());
        if ((dataPagamento !== null))
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: lightgreen; text-align: right;font-weight: bold";
          else
          e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
        }

        else if (dataScadenza < TodayFormatted()) 
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: red; text-align: right; font-weight: bold";
          else
            e.cellElement.style.cssText = "color: red; font-weight: bold";
        }

        else if ((dataScadenza < SevenDaysFormatted()) &&  (dataScadenza > TodayFormatted()) )
        {
          if(e.column.dataField === "giorniScadenza")
            e.cellElement.style.cssText = "color: orange; text-align: right; font-weight: bold";
          else
            e.cellElement.style.cssText = "color: orange; font-weight: bold";
        }
          
      }
    }
  }

  function onToolbarPreparing(e) {
    var item = e.toolbarOptions.items.find(item => item.name === "addRowButton"); 
      if(!allowPayment())
        item.options.visible = false;
  };

  function allowPayment() {
    console.log("STATO: " + props.status )
    //se Emessa o Pagata
    if(props.status == 3 || props.status === 5)
      return true
    else
      return false     
  };

  function onRowInserting(e) {
    e.data.updateBy = user.name;
    e.data.aziendaId = props.data.intermediarioId;
    e.data.fatturaFornitoreId = props.data.id;
    e.data.tipoTransazioneId = PAGAMENTI;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  function onInitNewRow(e) {
    e.data.dataScadenza = props.data.dataScadenza;
    e.data.dataRiferimento = new Date();

    const totale = Number(props.data.importoTotale) || 0;

    if (!hasPagamenti) {
      // ✅ Primo pagamento: tutto il totale della fattura
      //e.data.importoTotale = props.data.importoTotale;
      e.data.importoTotale = totale;
      e.data.saldo = props.data.importoTotale;
      e.data.importoTotalePagato = 0;
      e.data.importoParziale = 0;
      e.data.descrizione = 'Pagamento spesa n° ' + props.data.numeroDoc  + ' del ' + props.data.strDataDoc;
    } else {
      // ✅ Ci sono già pagamenti parziali: ricalcolo i residui
      const allRows = transactionsSupplierDataGridRef.instance().getVisibleRows().map(r => r.data);
      const totalePagato = allRows.reduce((sum, r) => sum + (r.importoParziale || 0), 0);
      const residuo = props.data.importoTotale - totalePagato;

      e.data.importoTotale = props.data.importoTotale;
      e.data.importoTotalePagato = totalePagato;
      e.data.saldo = residuo;
      e.data.importoParziale = residuo; // oppure 0, se vuoi che l’utente lo inserisca
      e.data.descrizione = 'Pagamento parziale spesa n° ' + props.data.numeroDoc + ' del ' + props.data.strDataDoc;
    }

    e.data.dataDocumento = props.data.dataDoc;
    e.data.dataScadenza = props.data.dataScadenza;
    e.data.tipoTransazioneId = 1;
    e.data.fatturaFornitoreId = props.data.id;

  };

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data !== null && data !== undefined) {
      setCurrentRow(data.id);
      setIsRowSelected(true);
      
    } else{
      setIsRowSelected(false);
    }
      
  }

  function blockMov(e) {
    blocca(currentRow);
  };
    
  function unBlockMov(e) {
    sblocca(currentRow);
  };
    
  const blocca= (idMovimento) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Transazione/Block/' + idMovimento;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
      
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        transactionsSupplierDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }
    
  const sblocca= (idMovimento) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Transazione/UnBlock/' + idMovimento;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        transactionsSupplierDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const hideEditButton = useCallback((e) => {
    return e.row.data.statoId !== 1;
  }, []);
    
  async function setDueValues(newData, value, currentRowData) {
    newData.importoParziale = value;
    //aggiunta
    //currentRowData.importoResiduo = currentRowData.importoTotale - currentRowData.saldo;
    newData.saldo = currentRowData.importoTotale - currentRowData.importoTotalePagato - value;
  };

  // const selectBoxOptions = {
  //   width: 200,
  //   items: commesse,
  //   valueExpr: 'id',
  //   displayExpr: 'nomeEsteso',
  //   placeholder:"<Commessa>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setCommessaFilter(args.value);
  //   },
  //   value: commessaFilter
  // };
    
  // const selectBoxOptions2 = {
  //   width: 210,
  //   items: intermediari,
  //   valueExpr: 'id',
  //   displayExpr: 'ragioneSociale',
  //   placeholder:"<Azienda>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setIntermediarioFilter(args.value);
  //   },
  //   value: intermediarioFilter,
  // };

    return (
      <DataGrid
        dataSource={remoteDataSourceDue}
        onContentReady={(e) => {
          const count = e.component.getVisibleRows().length;
          setHasPagamenti(count > 0);
        }}
        focusedRowEnabled={true}
        onCellPrepared={onCellPreparedDue}
        onSelectionChanged={onRowSelectionChanged}
        //onExporting={onExporting}
        onToolbarPreparing = {onToolbarPreparing}
        onRowUpdating={onRowUpdating}
        onRowInserting={onRowInserting}
        onInitNewRow={onInitNewRow}
        dateSerializationFormat= {'yyyy-MM-dd'}
        ref={ref => transactionsSupplierDataGridRef = ref}
      >

      <SearchPanel visible={true} width={240} placeholder="Cerca..." />
      <HeaderFilter visible={true} />
      <Selection mode="single" />
        <Toolbar>
          <Item name="addRowButton"/>   
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='key'
              hint='Blocca'
              onClick={blockMov} 
              disabled={!isRowSelected}
            />
          </Item>
          <Item location="before">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Sblocca'
              onClick={unBlockMov} 
              disabled={!isRowSelected}
            />
          </Item>
        
        
        </Toolbar>
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}    
        >

        

        <Popup   title= "&nbsp;&nbsp;&nbsp;Pagamento " showTitle={true} width={800} height={625} />
         
        <Form>
            <Item itemType="group" caption="" colCount={2} colSpan={2}>
            
                <Item dataField="descrizione" colSpan={2} />
                <Item dataField="dataRiferimento"/>
                <Item dataField="dataScadenza"/>
                <Item dataField="importoTotale" editorType="dxNumberBox" editorOptions={editorOptions}/>
                <Item dataField="importoTotalePagato" editorType="dxNumberBox" editorOptions={editorOptions}/>
                 <Item dataField="saldo" editorType="dxNumberBox" editorOptions={editorOptions}/>
                <Item itemType="empty"/> 
                <Item dataField="importoParziale" editorType="dxNumberBox" editorOptions={editorOptions}/>
                <Item dataField="dataPagamento" editorType="dxDateBox" /> 
                <Item dataField="modalitaPagamentoId" editorType="dxSelectBox" />  
                <Item dataField="categoriaAnaliticaId" editorType="dxSelectBox" /> 
                <Item dataField="note" colSpan={2} editorType="dxTextArea" />
            
          
            </Item> 
          </Form>
        </Editing>
        <Column dataField="id" caption="#" visible={false}/>
        <Column dataField="rata" caption="Rata" width={60} allowEditing={false}/>
        <Column dataField="descrizione" width={400} allowHeaderFiltering={false} allowEditing={false}/>
        <Column dataField="dataRiferimento" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true} allowEditing={false}/>
        <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true} allowEditing={false}/>
    
        <Column dataField="importoTotale" allowHeaderFiltering={false} caption="Importo Totale" allowEditing={false} >
          <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
        </Column>
        <Column dataField="importoRata" visible={false} allowHeaderFiltering={false} caption="Importo Rata" allowEditing={false} >
          <Format type="fixedPoint" precision={2} allowHeaderFiltering={false}/>
        </Column>
        <Column dataField="importoParziale"  caption="Importo pagato" allowHeaderFiltering={false} setCellValue={setDueValues}>
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="importoTotalePagato" visible={false} allowEditing={false} caption="Totale già pagato">
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="saldo" allowHeaderFiltering={false} allowEditing={false}>
          <Format type="fixedPoint" precision={2} />
        </Column>
        <Column dataField="dataPagamento" dataType="date" format= {'dd/MM/yyyy'} allowHeaderFiltering={true} caption="Data pagamento">
          <RequiredRule/>
        </Column>
        <Column dataField="modalitaPagamentoId" caption="Modalità Pagamento" width={100} visible={false}>
          <Lookup dataSource={modalitaPagam} displayExpr="descrizione" valueExpr="id" />
          <RequiredRule/>
        </Column>
        <Column dataField="categoriaAnaliticaId" caption="Categoria" width={100} visible={false}>
          <Lookup dataSource={categorie} displayExpr="descrizione" valueExpr="id" />
        </Column>
        <Column type="buttons">
          <Button name="edit" visible={hideEditButton} />
          <Button name="delete" visible={hideEditButton}/>
        </Column>
    </DataGrid>
    )
}